import {useEffect} from 'react';
import {AbsoluteCenter, Box, Heading} from '@chakra-ui/react';

const Jumbotron = () => {

  useEffect(() => {
    document.body.style.background = 'none';
  }, []);


  return (
    <Box
      h="100vh"
      w="100vw"
      borderRadius="10%"
      // border="groove 25px cyan"
      boxShadow="inset 0 0 50px 1px #0ff"
      bg="#0007"
    >
      <AbsoluteCenter>
        <Heading textShadow="0 0 15px #f1f" fontFamily="cursive" fontSize="10em" textAlign="center" color="#f1fa">UJG</Heading>
        <Heading textShadow="0 0 15px #faa" fontFamily="ui-monospace" fontSize="4em" textAlign="center" color="#faaa">Big Event Today!!!</Heading>
      </AbsoluteCenter>
    </Box>

  );
};

export default Jumbotron;